import type { IconComponent } from "@overmap-ai/blocks"

import { ProjectTimelineItemType, ProjectTimelineItemTypeGroup } from "../enums/projects"
import { modelIconMapping } from "./icons"

export const projectTimelineItemTypeData: Record<
	ProjectTimelineItemType,
	{ icon: IconComponent; label: string; group: ProjectTimelineItemTypeGroup }
> = {
	[ProjectTimelineItemType.ASSET]: {
		icon: modelIconMapping.assetType,
		label: "Assets",
		group: ProjectTimelineItemTypeGroup.ASSETS,
	},
	[ProjectTimelineItemType.ASSET_COMMENT]: {
		icon: modelIconMapping.comment,
		label: "Asset comments",
		group: ProjectTimelineItemTypeGroup.ASSETS,
	},
	[ProjectTimelineItemType.ASSET_ATTACHMENT]: {
		icon: modelIconMapping.attachment,
		label: "Asset attachments",
		group: ProjectTimelineItemTypeGroup.ASSETS,
	},
	[ProjectTimelineItemType.ASSET_FIELD_VALUES]: {
		icon: modelIconMapping.form,
		label: "Asset field values",
		group: ProjectTimelineItemTypeGroup.ASSETS,
	},
	[ProjectTimelineItemType.ASSET_IDENTIFIER_VALUE]: {
		icon: modelIconMapping.identifier,
		label: "Asset identifier values",
		group: ProjectTimelineItemTypeGroup.ASSETS,
	},
	[ProjectTimelineItemType.DOCUMENT]: {
		icon: modelIconMapping.document,
		label: "Documents",
		group: ProjectTimelineItemTypeGroup.DOCUMENTS,
	},
	[ProjectTimelineItemType.GEO_IMAGE]: {
		icon: modelIconMapping.camera,
		label: "Geo images",
		group: ProjectTimelineItemTypeGroup.GEO_IMAGES,
	},
	[ProjectTimelineItemType.ISSUE_ASSOCIATION]: {
		icon: modelIconMapping.link,
		label: "Issue associations",
		group: ProjectTimelineItemTypeGroup.ISSUES,
	},
	[ProjectTimelineItemType.ISSUE_ATTACHMENT]: {
		icon: modelIconMapping.attachment,
		label: "Issue attachments",
		group: ProjectTimelineItemTypeGroup.ISSUES,
	},
	[ProjectTimelineItemType.ISSUE_COMMENT]: {
		icon: modelIconMapping.comment,
		label: "Issue comments",
		group: ProjectTimelineItemTypeGroup.ISSUES,
	},
	[ProjectTimelineItemType.ISSUE]: {
		icon: modelIconMapping.issue,
		label: "Issues",
		group: ProjectTimelineItemTypeGroup.ISSUES,
	},
	[ProjectTimelineItemType.ISSUE_FIELD_VALUES]: {
		icon: modelIconMapping.form,
		label: "Issue field values",
		group: ProjectTimelineItemTypeGroup.ISSUES,
	},
	[ProjectTimelineItemType.ISSUE_IDENTIFIER_VALUE]: {
		icon: modelIconMapping.identifier,
		label: "Issue identifier values",
		group: ProjectTimelineItemTypeGroup.ISSUES,
	},
	[ProjectTimelineItemType.ISSUE_UPDATE]: {
		icon: modelIconMapping.edit,
		label: "Issue updates",
		group: ProjectTimelineItemTypeGroup.ISSUES,
	},
	[ProjectTimelineItemType.FORM_SUBMISSION]: {
		icon: modelIconMapping.form,
		label: "Form submissions",
		group: ProjectTimelineItemTypeGroup.FORMS,
	},
	[ProjectTimelineItemType.PROCEDURE_INITIATIVE]: {
		icon: modelIconMapping.procedureInitiave,
		label: "Procedure initiatives",
		group: ProjectTimelineItemTypeGroup.PROCEDURES,
	},
	[ProjectTimelineItemType.PROCEDURE_FIELD_VALUES]: {
		icon: modelIconMapping.form,
		label: "Procedure field values",
		group: ProjectTimelineItemTypeGroup.PROCEDURES,
	},
	[ProjectTimelineItemType.PROCEDURE]: {
		icon: modelIconMapping.checklist,
		label: "Procedures",
		group: ProjectTimelineItemTypeGroup.PROCEDURES,
	},
	[ProjectTimelineItemType.PROCEDURE_STEP_COMMENT]: {
		icon: modelIconMapping.comment,
		label: "Procedure step comments",
		group: ProjectTimelineItemTypeGroup.PROCEDURES,
	},
	[ProjectTimelineItemType.PROCEDURE_STEP_FIELD_VALUES]: {
		icon: modelIconMapping.form,
		label: "Procedure step field values",
		group: ProjectTimelineItemTypeGroup.PROCEDURES,
	},
	[ProjectTimelineItemType.PROCEDURE_STEP_EVENT]: {
		icon: modelIconMapping.history,
		label: "Procedure step events",
		group: ProjectTimelineItemTypeGroup.PROCEDURES,
	},
	[ProjectTimelineItemType.PROCEDURE_STEP_REVIEW]: {
		icon: modelIconMapping.reviewer,
		label: "Reviews",
		group: ProjectTimelineItemTypeGroup.PROCEDURES,
	},
	[ProjectTimelineItemType.PROJECT_ATTACHMENT]: {
		icon: modelIconMapping.attachment,
		label: "Project attachments",
		group: ProjectTimelineItemTypeGroup.ATTACHMENTS,
	},
	[ProjectTimelineItemType.PROJECT_COMMENT]: {
		icon: modelIconMapping.comment,
		label: "Project comments",
		group: ProjectTimelineItemTypeGroup.COMMENTS,
	},
}

export const projectTimelineItemTypeGroupData: Record<
	ProjectTimelineItemTypeGroup,
	{ icon: IconComponent; label: string }
> = {
	[ProjectTimelineItemTypeGroup.ASSETS]: {
		label: "Assets",
		icon: modelIconMapping.assetType,
	},
	[ProjectTimelineItemTypeGroup.DOCUMENTS]: {
		label: "Documents",
		icon: modelIconMapping.document,
	},
	[ProjectTimelineItemTypeGroup.GEO_IMAGES]: {
		label: "Geo images",
		icon: modelIconMapping.camera,
	},
	[ProjectTimelineItemTypeGroup.ISSUES]: {
		label: "Issues",
		icon: modelIconMapping.issue,
	},
	[ProjectTimelineItemTypeGroup.FORMS]: {
		label: "Forms",
		icon: modelIconMapping.form,
	},
	[ProjectTimelineItemTypeGroup.PROCEDURES]: {
		label: "Procedures",
		icon: modelIconMapping.procedureType,
	},
	[ProjectTimelineItemTypeGroup.COMMENTS]: {
		label: "Comments",
		icon: modelIconMapping.comment,
	},
	[ProjectTimelineItemTypeGroup.ATTACHMENTS]: {
		label: "Attachments",
		icon: modelIconMapping.attachment,
	},
}
